module.exports = __webpack_public_path__ + "img/Infantil.acabd7fc.svg";